import axiosIns from '@/plugins/axios'

export default {
  // カスタムフィールド一覧を取得
  getCustomerCustomFields() {
    return axiosIns.get('/waiter/customer_custom_fields')
  },

  // カスタムフィールドを作成
  createCustomerCustomField(data) {
    return axiosIns.post('/waiter/customer_custom_fields', {
      customer_custom_field: data,
    })
  },

  // カスタムフィールドを更新
  updateCustomerCustomField(id, data) {
    return axiosIns.patch(`/waiter/customer_custom_fields/${id}`, {
      customer_custom_field: data,
    })
  },

  // カスタムフィールドを削除
  deleteCustomerCustomField(id) {
    return axiosIns.delete(`/waiter/customer_custom_fields/${id}`)
  },
}
